module.exports = __webpack_public_path__ + "fecb5d2bbb206947882382fefed393d5.svg";